import { Typography } from "@mui/joy";
import { currencyColumn, dateColumn, genericColumn, getColumnValue, numberColumn, textColumn, textareaColumn, yesNoColumn } from "./columnHelpers";

export const transformationStrategiesRelationship = {
    collapsible: true,
    title: 'Transformation Strategies',
    tint: 'default',
    type: 'table',
    columns: [
        textareaColumn({label: 'Goal', column: 'goal'}),
        textareaColumn({label: 'Results', column: 'result'}),
        yesNoColumn({label: 'Accomplished', column: 'goal_met'}),
    ],
};
